import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminCapability, AppCapability, hasAdminCapability, hasAppCapability, useAuth, UserRole } from '@services/auth';

type RoleGateProps = {
	allowed: UserRole[];
	children: ReactNode;
	redirectTo?: string;
	adminCapability?: AdminCapability;
	appCapability?: AppCapability;
};

export default function RoleGate({
	allowed,
	children,
	redirectTo = '/app/dashboard',
	adminCapability,
	appCapability
}: RoleGateProps) {
	const { user } = useAuth();

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	if (!allowed.includes(user.role)) {
		return <Navigate to={redirectTo} replace />;
	}

	if (user.role === 'admin' && adminCapability && !hasAdminCapability(user, adminCapability)) {
		return <Navigate to={redirectTo} replace />;
	}

	if (appCapability && !hasAppCapability(user, appCapability)) {
		return <Navigate to={redirectTo} replace />;
	}

	return <>{children}</>;
}


